import React from 'react';

const IconYoutube = ({ className }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="49"
      height="48"
      fill="none"
      viewBox="0 0 49 48"
      className={className}
    >
      <circle cx="24.995" cy="24" r="23" stroke="currentColor" strokeWidth="2" />
      <path
        fill="currentColor"
        d="M36.464 17.93l.03.195c-.29-1.029-1.073-1.823-2.068-2.112l-.02-.005c-1.872-.508-9.4-.508-9.4-.508s-7.51-.01-9.4.508c-1.015.294-1.799 1.088-2.084 2.096l-.005.021c-.699 3.651-.704 8.038.031 11.947l-.03-.198c.29 1.03 1.072 1.823 2.067 2.112l.021.005c1.87.51 9.4.51 9.4.51s7.51 0 9.4-.51c1.015-.294 1.8-1.088 2.084-2.096l.005-.02c.318-1.699.5-3.653.5-5.649v-.22-.23c0-1.998-.182-3.952-.53-5.847zm-13.86 9.721v-7.293l6.265 3.652-6.266 3.641z"
      />
    </svg>
  );
};

export default IconYoutube;
